import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DesactivarCustomerModalComponent } from "./desactivar-customer-modal.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        DesactivarCustomerModalComponent
    ],
    exports: [
        DesactivarCustomerModalComponent
    ]
})
export class DesactivarCustomerModalModule { }
